import { Component } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-documents-preview-modal",
  templateUrl: "./documents-preview-modal.component.html",
  styleUrls: ["./documents-preview-modal.component.scss"],
})
export class DocumentsPreviewModalComponent {
  public file: File;

  constructor(private bsModalRef: BsModalRef) {}

  private getFilePreviewURL(file: File): string {
    return URL.createObjectURL(file);
  }

  public closeModal = (): void => this.bsModalRef.hide();
}
